import { PROFILE_LEVEL, type Profile } from '../types/profile';

export function canViewProfileContent(currentProfile: Profile, contentProfile: Profile) {
  return PROFILE_LEVEL[currentProfile] >= PROFILE_LEVEL[contentProfile];
}
